import { render, staticRenderFns } from "./LoadingButton.vue?vue&type=template&id=18109016&scoped=true"
import script from "./LoadingButton.vue?vue&type=script&lang=js"
export * from "./LoadingButton.vue?vue&type=script&lang=js"
import style0 from "./LoadingButton.vue?vue&type=style&index=0&id=18109016&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18109016",
  null
  
)

export default component.exports